import { Document, Page } from "@react-pdf/renderer";
import CoverPage from "../../assets/coverPage/CoverPage";
import PageFooter from "../../assets/footer/PageFooter";
import ContractStyles from "../../assets/styles/contractStyles";
import RIContractContent from "./RIContractContent";

const RIContractPDF = ({ contractDetails = {} }) => {
  const styles = ContractStyles();
  return (
    <Document>
      <CoverPage
        contractName="Adviser Agreement"
        adviserName={ "Adviser Name"}
        ARName={ "AR Name"}
      />
      <Page
        size="A4"
        style={[styles.page, styles.gap_md, { paddingBottom: 84 }]}
      >
        <RIContractContent contractDetails={contractDetails} />
        <PageFooter startPage={2} agreementTitle="Adviser Agreement" />
      </Page>
    </Document>
  );
};

export default RIContractPDF;
